import { useState } from "react";
import { Modal } from "react-bootstrap";

const DijiKolayPopup = ({ show, img, title, url, width }) => {
  const [modalShow, setModalShow] = useState(show);

  const handleClose = () => setModalShow(false);
  return (
    <Modal
      className="modal-img modal-diji"
      show={modalShow}
      onHide={handleClose}
    >
      <Modal.Dialog>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <a
            href="https://www.isbank.com.tr/is-ticari/dijikolay"
            target="_blank"
          >
            <div className="row">
              <div className="col-md-6">
                <img
                  src="/popup/pop-dijikolay-2.png"
                  style={{ height: "auto", width: "100%" }}
                  alt={title}
                />
              </div>
              <div className="col-md-6">
                <img
                  src="/popup/pop-dijikolay-1.png"
                  style={{ height: "auto", width: "100%" }}
                  alt={title}
                />
              </div>
            </div>
          </a>
          <div className="row justify-content-center p-3">
            <div className="col-md-4">
              <a
                href="https://www.isbank.com.tr/is-ticari/dijikolay"
                className="btn btn-primary"
                target="_blank"
              >
                HEMEN BAŞVUR
              </a>
            </div>
          </div>
        </Modal.Body>
      </Modal.Dialog>
    </Modal>
  );
};

export default DijiKolayPopup;
